import React, { FC, useMemo } from 'react';
import NavItem from './NavItem/NavItem';
import cn from 'classnames';
import * as classes from './NavList.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { NavMenu } from '../../../../../interfaces/nav/NavMenu';

interface Props extends NavMenu {
  className?: string;
  isVerticalNav?: boolean;
  withSeparator?: boolean;
  itemClickAction?: () => void;
  isWhite?: boolean;
}

const NavList: FC<Props> = ({ items, titleKey, className, itemClickAction, isVerticalNav, withSeparator, isWhite }) => {
  const { t } = useTranslation();

  const listTitle = useMemo(() => {
    if (titleKey && isVerticalNav) {
      return <div className={classes.title}>{t(titleKey)}</div>;
    }
    return null;
  }, [isVerticalNav, t, titleKey]);

  const itemsList = useMemo(() => {
    return items.map(item => {
      return (
        <NavItem
          key={item.title}
          path={t(item.url)}
          title={t(item.title)}
          isVerticalItem={isVerticalNav}
          withSeparator={withSeparator}
          isExternalLink={item.isExternalLink}
          isTargetBlank={item.isTargetBlank}
          clickAction={itemClickAction}
          isWhite={isWhite}
        >
          {t(item.label)}
        </NavItem>
      );
    });
  }, [isVerticalNav, isWhite, itemClickAction, items, t, withSeparator]);

  const listClassNames = useMemo(() => {
    if (isVerticalNav) {
      return className;
    }
    return cn(classes.horizontalList, className);
  }, [className, isVerticalNav]);

  return (
    <div className={classes.wrapper}>
      {listTitle}
      <ul className={listClassNames}>{itemsList}</ul>
    </div>
  );
};

export default NavList;
